<div class="row small">
    <div class="col-md-3">
        <div class="fw-semibold">Time</div>
        <div>{{ entry()?.startDate }} {{ entry()?.startTime }} – {{ entry()?.endDate }} {{ entry()?.endTime }}</div>
    </div>

    <div class="col-md-3">
        <div class="fw-semibold">Work / Activity</div>
        <div>{{ entry()?.workCode || '—' }}</div>
        <div class="text-muted">{{ entry()?.activityType || '—' }}</div>
        @if (entry()?.afterHourCallOut) {
            <span class="badge text-bg-warning mt-1">After-Hours</span>
        }
    </div>

    <div class="col-md-3">
        <div class="fw-semibold">Travel</div>
        <div>Mode: {{ entry()?.meansOfTransport || '—' }}</div>
        <div>
            Billable:
            <span
                class="badge"
                [class.text-bg-success]="entry()?.isTravelBillable"
                [class.text-bg-secondary]="!entry()?.isTravelBillable"
            >
                {{ entry()?.isTravelBillable ? 'Yes' : 'No' }}
            </span>
        </div>
        <div>Distance: {{ formatedDistance()}</div>
    </div>

    <div class="col-md-3">
        <div class="fw-semibold">Address</div>
        <div>{{ formattedAddress() }}</div>
        @if (entry()?.addressInOutModel) {
            <span class="badge text-bg-info mt-1">IN/OUT</span>
        }
    </div>
</div>
